export default "__VITE_ASSET__T3B3x1IV__"